module.exports = __webpack_public_path__ + "static/media/rob.56446831.png";